var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _path8, _rect5, _rect6, _rect7, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 27,
    viewBox: "0 0 38 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24.4854,
    width: 37.7048,
    height: 2.21793,
    rx: 1.10897,
    fill: "#216651"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.84858 15.9834C2.25689 15.9834 2.58789 16.3144 2.58789 16.7227L2.58789 24.1158L1.10927 24.1158L1.10927 16.7227C1.10927 16.3144 1.44027 15.9834 1.84858 15.9834Z",
    fill: "#216651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1326 17.8311C9.76584 17.8311 11.0898 19.1551 11.0898 20.7883L11.0898 24.1152L5.17536 24.1152L5.17536 20.7883C5.17536 19.1551 6.49937 17.8311 8.1326 17.8311Z",
    fill: "#216651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4064 17.8311C20.5292 17.8311 21.4395 18.7413 21.4395 19.8642L21.4395 24.1152L17.3732 24.1152L17.3732 19.8642C17.3732 18.7413 18.2835 17.8311 19.4064 17.8311Z",
    fill: "#216651"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7051 21.8985L37.7051 24.1164L29.5727 24.1164L29.5727 21.8985C30.3711 22.4312 30.9626 22.4312 31.4949 21.8985C31.6343 21.7173 31.7706 21.5695 31.9037 21.4549L33.1662 21.4549C33.2776 21.5695 33.3859 21.7173 33.491 21.8985C34.2895 22.8842 34.9548 22.8842 35.4871 21.8985C35.9079 21.326 36.7951 21.326 37.7051 21.8985Z",
    fill: "#216651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1662 21.4549L31.9037 21.4549C32.3618 21.0606 32.7826 21.0606 33.1662 21.4549Z",
    fill: "#216651"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7051 24.1164L37.7051 21.8985C36.7951 21.326 35.9079 21.326 35.4871 21.8985C34.9548 22.8842 34.2895 22.8842 33.491 21.8985C33.3859 21.7173 33.2776 21.5695 33.1662 21.4549L31.9037 21.4549C31.7706 21.5695 31.6343 21.7173 31.4949 21.8985C30.9626 22.4312 30.3711 22.4312 29.5727 21.8985L29.5727 24.1164L37.7051 24.1164Z",
    fill: "#216651"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7051 24.1164L37.7051 21.8985C36.7951 21.326 35.9079 21.326 35.4871 21.8985C34.9548 22.8842 34.2895 22.8842 33.491 21.8985C33.3859 21.7173 33.2776 21.5695 33.1662 21.4549L31.9037 21.4549C31.7706 21.5695 31.6343 21.7173 31.4949 21.8985C30.9626 22.4312 30.3711 22.4312 29.5727 21.8985L29.5727 24.1164L37.7051 24.1164Z",
    fill: "#216651"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21.4395,
    y: 11.917,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 21.4395 11.917)",
    fill: "#216651"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7246,
    y: 11.917,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 27.7246 11.917)",
    fill: "#216651"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7246,
    y: 18.2021,
    width: 4.06621,
    height: 4.06621,
    rx: 2,
    transform: "rotate(90 27.7246 18.2021)",
    fill: "#216651"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 4.52441C14.8233 4.52441 15.1543 4.85541 15.1543 5.26372L15.1543 24.1161L13.6757 24.1161L13.6757 5.26372C13.6757 4.85541 14.0067 4.52441 14.415 4.52441Z",
    fill: "#216651"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.9922,
    y: 8.19629,
    width: 16.78,
    height: 1.77065,
    rx: 0.885324,
    transform: "rotate(145.213 14.9922 8.19629)",
    fill: "#216651"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 21.3828,
    y: 1.4541,
    width: 9.58645,
    height: 1.77065,
    rx: 0.885324,
    transform: "rotate(145.213 21.3828 1.4541)",
    fill: "#216651"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7578,
    y: 12.0791,
    width: 18.0332,
    height: 1.77152,
    rx: 0.885759,
    transform: "rotate(-144.347 33.7578 12.0791)",
    fill: "#216651"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5283 9.7002C32.9366 9.7002 33.2676 10.0312 33.2676 10.4395L33.2676 17.8326L31.789 17.8326L31.789 10.4395C31.789 10.0312 32.12 9.7002 32.5283 9.7002Z",
    fill: "#216651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ace845c2081c4c9d913b9c92d164f4b0.svg";
export { ForwardRef as ReactComponent };